import PlayIcon from 'assets/icons/play.png'

const CategorySection = () => {
  return (
    <>
      <div className="w-[980px] flex flex-col gap-6 mt-5 mb-20 mx-auto text-center">
        <h2 className="font-bold text-[48px] leading-[62px] tracking-0 text-[#967037]">
          Celebrating the Best of Our Network
        </h2>
        <p className="text-[#271903] leading-6 text-16">
          On this journey from good to great, we take a proud annual moment to raise a <br />
          toast, or a few, to celebrate the daring, the disruptive, and the downright <br /> exceptional in marketing.
        </p>

        <div className="mx-auto w-fit p-6 pb-10 ">
          <button
            className="border border-solid text-14 font-semibold border-black rounded-[40px] flex items-center py-2.5 px-4 bg-[#EBFF00] text-black hover:bg-[#DFB26D] hover:text-white"
            onClick={() => window.open(process.env.REACT_APP_NMA_GAME_AWARD_CEREMONY_URL)}
          >
            <img src={PlayIcon} className="w-4 h-4 mr-1" alt="play" />
            <span>Watch the 2025 NMA Ceremony recording</span>
          </button>
        </div>
      </div>
      {/* <div className="mx-auto max-w-[1136px] flex gap-8 flex-wrap mb-20">
        {CategorySectionData.map(item => (
          <Card key={item.title} category={item} />
        ))}
      </div> */}
    </>
  )
}

export default CategorySection
